const styles = {
    blue: {
        color: 'rgb(33,77,142)',
        paddingRight: "0"
    },
    red: {
        color: "rgb(220,38,72)",
        paddingLeft: "0"
    },
    black: {
        color: "rgb(45,45,45)"
    },
    headerText: {
        display: 'inline',
        margin: '0',
        padding: '0'
    },
    headerWrapper: {
        padding: "0",
        margin: "0",
        paddingTop: "15px",
        height: "57px",
        paddingBottom: "39px",
        background: "rgb(247,249,249)"
    },
    logo: {
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: '7px',
        width: '130px'
    },
    secondHeader: {
        fontSize: "12px",
        lineHeight: "15px",
        textAlign: "center",
        color: '#434343',
        letterSpacing: '-0.2px',
        fontFamily: 'Roboto, sans-serif',
        fontStretch: 'normal',
        fontWeight: 'normal',
    },
    formHeaderWrapper: {
        padding: "0",
        margin: "0",
    },
    formHeaderH1: {
        textAlign: 'center',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '24px',
        lineHeight: '28px',
        color: '#3b3b3b',
        paddingTop: '24px',
        fontWeight: 'normal'
    },
    formHeaderH2:{
        textAlign: 'center',
        fontFamily: 'Roboto, sans-serif',
        fontSize: '14px',
        lineHeight: '16px',
        color: '#3b3b3b',
        fontWeight: 'normal',
        paddingTop: '5px'
    }
}
export default styles;
